import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import {
  Grid,
  IconButton,
  Tooltip,
} from '@mui/material';
import { useRef } from 'react';
import { gridSizeMdLg1 } from '@/shared/constants';
import Flatpickr from 'react-flatpickr';
import DateRangePicker from '@/shared/components/ui/CustomSearch/DateRangePicker';
import { gridSizeMdLg3, hasPermission } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';

export interface CustomSearchInterface {
  value: string;
  text: string;
  onChange: (value: any) => void;
  setVendedor: React.Dispatch<React.SetStateAction<string>>
  //vendedor: string
  customBox?: React.ReactNode;
  onChangeRangeDate?: (range: Date[]) => void;
  cleanFilter?: () => void;
}

const CustomSearchFilterSupervisorVenta: React.FC<CustomSearchInterface> = ({
  //filter date
  onChangeRangeDate,
  cleanFilter,
  // custom box
  //setVendedor,
}) => {
  const flatpickrRef = useRef<Flatpickr>(null);

  return (
    <Grid
      item
      container
      spacing={1}
      alignItems="center"
      justifyContent={'flex-end'}
    >
      {/* {hasPermission(PermissionsEnum.api_view_empleado) && (
        <CustomAutocompleteNoForm<Empleado>
          size={gridSizeMdLg2}
          label={'Vendedor'}
          options={empleado || []}
          valueKey="razon_social"
          disableClearable={true}
          actualValueKey="user"
          defaultValue={vendedor}
          isLoadingData={isLoadingEmpleado}
          onChangeValue={(e) => {
            setVendedor(e)
          }}
        />
      )} */}
      
      {hasPermission(PermissionsEnum.api_view_empleado) && (
        <Grid item {...gridSizeMdLg3}>
          {/* <CustomAutoCompleteVendedor
            onChangeValue={(value) => {

              setVendedor(value.user ?? '')
            }}
          /> */}
        </Grid>
      )
      }


      {onChangeRangeDate && (
        <DateRangePicker
          size={gridSizeMdLg3}
          flatpickrRef={flatpickrRef}
          onChange={range => onChangeRangeDate(range)}
        />
      )}

      <Grid item {...gridSizeMdLg1}>
        <Tooltip title="Limpiar">
          <IconButton
            onClick={() => {
              //LIMPIAR RANGO DE FECHAS FRONT
              if (flatpickrRef.current) {
                flatpickrRef.current.flatpickr.clear();
              }

              cleanFilter && cleanFilter();
            }}
          >
            <FilterAltOffIcon />
          </IconButton>
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default CustomSearchFilterSupervisorVenta;
